module.exports = __webpack_public_path__ + "img/PA.89751e8b.png";